import React, { useState } from 'react'
import { TextInput, TextInputProps } from 'react-native'

import { styled } from 'nativewind'

import { Stack, XStack } from '../layout'
import { Text } from '../typography/Typography'

const InputGroupFrame = styled(
  XStack,
  'flex-row h-10 border border-grays-40 rounded-md items-center'
)

const ErrorText = styled(
  Text,
  'font-normal text-xs text-grays-60	leading-4 pt-2'
)
const CountText = styled(
  Text,
  'font-normal text-xs text-grays-60	leading-4 pt-2'
)

interface textareaProps extends TextInputProps {
  label?: string
  showError?: boolean
  errorText?: string
  isRequired?: boolean
  showCount?: boolean
  countLimit?: number
}

export function Textarea({
  isRequired,
  label,
  showError,
  errorText,
  showCount,
  countLimit,
  ...props
}: textareaProps) {
  const [count, setCount] = useState(0)

  return (
    <Stack>
      {label && (
        <XStack className="pb-1">
          <Text className="text-grays-80 font-normal leading-5">{label}</Text>
          {isRequired && <Text className="text-error-150 pl-1">*</Text>}
        </XStack>
      )}
      <InputGroupFrame>
        <TextInput
          className="rounded-md p-2"
          multiline={true}
          onChangeText={(val) => {
            setCount(val.length)
          }}
          {...props}
        />
      </InputGroupFrame>
      {(showError || showCount) && (
        <XStack className="justify-between">
          {<ErrorText>{errorText}</ErrorText>}
          {showCount && <CountText>{`${count}/${countLimit}`}</CountText>}
        </XStack>
      )}
    </Stack>
  )
}
